import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";



const CustomSwitch = styled(Switch)(({ theme }) => ({
	padding: 8,
	"& .MuiSwitch-thumb": {
		width: 20,
		height: 20,
		backgroundColor: "#2B344A", // Default thumb color
		border: "1px solid #172036",
	},

	"& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
		backgroundColor: "#605DFF", // Thumb when checked
		border: "1px solid #172036",
	},

	"& .MuiSwitch-track": {
		borderRadius: 20,
		backgroundColor: "#0C1427",
		border: "1px solid #172036",
		opacity: 1,
	},
	"& .Mui-checked + .MuiSwitch-track": {
		backgroundColor: "#0C1427",
		border: "1px solid #172036",// Track stays same when checked
	},
}));

export default CustomSwitch;